module.exports = __webpack_public_path__ + "img/902b7e1.png";